import http from "./HttpService";

var endpoint = `/lookup/candidate/`;
/*
const getTitles = async () => {
  const response = await http.get(`${endpoint}titles`);
  return response;
};

const getRaces = async () => {
    const response = await http.get(`${endpoint}races`);
    return response;
  };

  const getGenders = async () => {
    const response = await http.get(`${endpoint}genders`);
    return response;
  };
*/
  const getQualifications = async () => {
    const response = await http.get(`${endpoint}qualifications`);
    return response;
  };
  
  const getDocTypes = async () => {
    const response = await http.get(`${endpoint}document/types`);
    return response;
  };

const getPlacementStatus = async () => {
  const response = await http.get(`${endpoint}placementStatus`);
  return response;
};
const getPreNYSActivity = async () => {
  const response = await http.get(`${endpoint}preNYSActivity`);
  return response;
};
const getExitDirection = async () => {
  const response = await http.get(`${endpoint}exitDirection`);
  return response;
};

const getDuration = async () => {
  const response = await http.get(`${endpoint}durationInNYS`);
  return response;
};

export default {
    getQualifications,
    getDocTypes,
    getPlacementStatus,
    getPreNYSActivity,
    getExitDirection,
    getDuration
  };